import React from 'react';
import { Box, Button, Paragraph } from 'bumbag';
import _get from 'lodash/get';
import type { NavigateFunction } from 'react-router-dom';
import { Link as RouterLink } from 'react-router-dom';

import { LandingPage } from '@medipass/react-core';
import { withRouter } from '@medipass/react-core/router';
import sdk from '@medipass/web-sdk';

import MedicareAccountForm from 'legacy/components/account/health-fund-accounts/MedicareAccountForm';
import WithAuthentication from 'legacy/components/WithAuthentication';
import { updateMembersHealthFundAccount } from 'legacy/utils/health-fund-accounts';
type Props = {
  navigate: NavigateFunction;
};

class CreateMedicareAccount extends React.PureComponent<Props> {
  handleAddMedicareAccount = async (medicareAccount: Record<string, any>) => {
    const { navigate } = this.props;

    const memberId = _get(sdk, 'member._id');

    const body = await updateMembersHealthFundAccount({
      healthFundAccount: medicareAccount,
      memberId,
    });
    navigate('/');
    return body;
  };
  handleClickCancel = () => {
    window.history.back();
  };
  render = () => (
    <WithAuthentication>
      <LandingPage
        description={
          <Paragraph>Add your Medicare card to enable us to instantly process any benefits owing to you.</Paragraph>
        }
        // @ts-expect-error
        isLight
        title="Add Medicare card"
      >
        <MedicareAccountForm
          isMobileTitle={false}
          isSubmitButtonInsideSection
          onSubmit={this.handleAddMedicareAccount}
          submitButtonRenderer={({ isLoading }) => (
            <Box textAlign="center">
              <Button palette="secondary" isLoading={isLoading} size="medium" width="100%" type="submit">
                CONTINUE
              </Button>
              <Button
                // @ts-expect-error
                use={RouterLink}
                to="/account/transactions/"
                palette="primary"
                marginTop="major-1"
                variant="ghost"
              >
                I{"'"}ll do this later
              </Button>
            </Box>
          )}
          title="Add your Medicare card"
        />
      </LandingPage>
    </WithAuthentication>
  );
}

export default withRouter(CreateMedicareAccount);
